import {BrandTraitKey} from "./bc-sheet/brand-trait";

export type ColorDefinition = {
  primary: string;
  secondary: string;
  accent: string;
}

export type ColorDefinitionKey = keyof ColorDefinition;

export const COLOR_DEFINITION_KEYS: ColorDefinitionKey[] = ["primary", "secondary", "accent"];

export type BrandTraitColors3 = {
  traitKey: BrandTraitKey;
  colors: ColorDefinition[];
}

export type RecommendedColors3Request = {
  rankedBrandTraits: BrandTraitKey[];
}

export type RecommendedColors3Response = BrandTraitColors3[];
